import { FC, ReactElement } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';

interface FilterTitleProps {
  children: ReactElement;
  closeDrawer: () => void;
  ariaLabel: string;
  backButtonAriaLable: string;
}

export const FilterTitle: FC<FilterTitleProps> = ({
  children,
  closeDrawer,
  ariaLabel,
  backButtonAriaLable,
}) => {
  return (
    <div slot="header" className="d-flex align-items-center">
      <CatButton
        hideText
        onClick={() => closeDrawer()}
        size="sm"
        variant="ghost"
        data-testid="custom-back-button"
      >
        <CatIconArrowBack slot="before" aria-label={backButtonAriaLable} />
      </CatButton>
      <CatHeading
        variant="title-sm"
        data-testid="filterByHeading"
        id="notification-filters-header"
        className="ms-3"
        aria-label={ariaLabel}
      >
        {children}
      </CatHeading>
    </div>
  );
};
